import { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const MotionLink = motion(Link);

// Floating "Book Now" CTA that fades in once the visitor scrolls past the
// hero, keeping the booking action always within reach.
export const StickyBookNow = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <MotionLink
          to="/book"
          initial={{ opacity: 0, y: 30, scale: 0.92 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.92 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="hidden lg:inline-flex fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-40 items-center gap-2 h-12 px-5 rounded-full bg-[hsl(var(--lxra-gold))] text-[#0A0A0A] shadow-lg shadow-black/40 hover:bg-[hsl(var(--lxra-gold-hover))] hover:-translate-y-0.5 transition-transform duration-200 text-xs uppercase tracking-[0.1em] font-semibold"
          data-testid="sticky-book-now-button"
        >
          Book Now
          <ArrowRight className="h-4 w-4" />
        </MotionLink>
      )}
    </AnimatePresence>
  );
};
